import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { tw } from 'twind';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  urls: string[];
  index: number;
}

const ImageModal = ({ isOpen, handleClose, index, urls }: Props) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const imageRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      return;
    }

    document.body.style.overflow = 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  useLayoutEffect(() => {
    if (!(isOpen && containerRef.current && imageRefs.current[index])) return;

    const container = containerRef.current;
    const targetImage = imageRefs.current[index];

    if (!targetImage) return;

    container.scrollTop = targetImage.offsetTop;
  }, [isOpen, index]);

  if (!isOpen) return null;

  return (
    <div
      className={tw`fixed top-0 left-0 right-0 bottom-0 bg-white flex justify-center items-center z-[1000] overflow-y-auto`}
      onClick={handleClose}
    >
      <div className={tw`relative w-full h-full flex flex-col items-center justify-center pt-[60px]`} onClick={(e) => e.stopPropagation()}>
        <button
          className={tw`absolute top-0 right-0 w-[60px] h-[60px] flex justify-center items-center bg-transparent border-none text-white text-[40px] cursor-pointer z-[1010]`}
          onClick={handleClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="17px" height="17px" role="presentation" viewBox="0 0 17 17">
            <path
              d="M1.284.089l.07.057 7.36 7.361 7.361-7.36.07-.058a.5.5 0 0 1 .637.765l-7.361 7.36 7.361 7.361a.5.5
  0 0 1-.638.765l-.069-.058-7.361-7.361-7.36 7.361-.07.058a.5.5 0 0 1-.638-.765l7.361-7.361L.647.854a.5.5 0 0
  1 .637-.765z"
              fill="#000"
              fillRule="nonzero"
            ></path>
          </svg>
        </button>
        <div className={tw`w-full h-full overflow-y-auto box-border`} ref={containerRef}>
          {urls.map((url, i) => (
            <div key={i} ref={(el) => (imageRefs.current[i] = el)} className={tw`flex items-center h-screen py-[40px] my-0 mx-[20px]`}>
              <img src={url} className={tw`w-full h-full object-contain`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
